import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
  projectId: '1x6hgqdo',
  dataset: 'production',
  apiVersion: '2022-02-01',
  useCdn: true,
  token: 'ski6XH8cRiBLQjQ32VI5uiGAMoeqVqCtmmMrK9z4c1zZmltyYKijX9SWfsnohMPO1zraJo5r5PetqE831rZjNuV5oLzmv6fdJUtvoQ2krJq1e94A36z6Kmdngfr4HeGLVj4FXRWK7REQQY257rjNFi8AIbhmqPMpEWEpyGKBIIr8eDYOGBsf',
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);
